export default (notification: any) => {
  // console.log('FooBar Event: ', notification);
};
